import {
  QueryKey,
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

export interface DowngradePlanRequest {
  planId: number;
}

export interface DowngradePlanResponse {
  nextOrderAt: string;
}

export const downgradePlan = (request: DowngradePlanRequest) => {
  return api.put<ApiResponse<DowngradePlanResponse>>(
    '/pay/cert/downgrade',
    request,
  );
};

const useDowngradePlan = (
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<DowngradePlanResponse>>,
    AxiosError<ApiErrorResponse>,
    DowngradePlanRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<DowngradePlanResponse>>,
  AxiosError<ApiErrorResponse>,
  DowngradePlanRequest,
  QueryKey
> => {
  return useMutation(downgradePlan, {
    ...options,
  });
};

export default useDowngradePlan;
